import React, { Component } from "react";

export default class SplitPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            splitPanelWidth: 60, // Percentage width for main panel
            isPanelOpen: false     // Whether the right panel is open
        };
        this.isResizing = false;
    }

    componentDidMount() {
        // Add mouse event listeners for resizing
        this.setupResizeHandlers();
    }

    componentWillUnmount() {
        // Clean up event listeners
        document.removeEventListener("mousemove", this.handleMouseMove);
        document.removeEventListener("mouseup", this.handleMouseUp);
    }

    setupResizeHandlers = () => {
        this.isResizing = false;
    }

    handleMouseDown = (e) => {
        this.isResizing = true;
        document.addEventListener("mousemove", this.handleMouseMove);
        document.addEventListener("mouseup", this.handleMouseUp);
        e.preventDefault();
    }

    handleMouseMove = (e) => {
        if (!this.isResizing) return;

        const container = document.getElementById("split-container");
        if (!container) return;

        const containerRect = container.getBoundingClientRect();
        const newWidth = ((e.clientX - containerRect.left) / containerRect.width) * 100;

        // Constrain between 20% and 80%
        if (newWidth >= 20 && newWidth <= 80) {
            this.setState({ splitPanelWidth: newWidth });
        }
    }

    handleMouseUp = () => {
        this.isResizing = false;
        document.removeEventListener("mousemove", this.handleMouseMove);
        document.removeEventListener("mouseup", this.handleMouseUp);
    }

    togglePanel = () => {
        this.setState(prevState => ({
            isPanelOpen: !prevState.isPanelOpen
        }));
    }

    render() {
        const { isPanelOpen, splitPanelWidth } = this.state;

        // Dynamic grid layout based on panel state
        const splitContainerStyles = {
            display: "grid",
            gridTemplateColumns: isPanelOpen
                ? `${splitPanelWidth}% 6px ${100 - splitPanelWidth}%`
                : "1fr",
            height: "calc(100vh - 120px)",
            gap: "0",
            position: "relative"
        };

        const resizeHandleStyles = {
            cursor: "col-resize",
            backgroundColor: "#e9ecef",
            border: "1px solid #dee2e6",
            display: isPanelOpen ? "flex" : "none",
            alignItems: "center",
            justifyContent: "center",
            userSelect: "none",
            position: "relative"
        };

        const resizeIndicatorStyles = {
            width: "3px",
            height: "30px",
            backgroundColor: "#6c757d",
            borderRadius: "1px",
            opacity: "0.7"
        };

        const mainPanelStyles = {
            overflow: "auto",
            position: "relative"
        };

        const rightPanelStyles = {
            overflow: "hidden",
            backgroundColor: "#f8f9fa",
            borderLeft: "1px solid #dee2e6",
            display: isPanelOpen ? "block" : "none"
        };

        const toggleButtonStyles = {
            position: "absolute",
            top: "10px",
            right: isPanelOpen ? "8px" : "8px",
            zIndex: 1000,
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            padding: "6px 6px",
            marginTop: "8px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "bold",
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            transition: "background-color 0.2s"
        };

        return (
            <div id="split-container" style={splitContainerStyles}>
                {/* Chat button hidden in prod */}
                <button
                    style={toggleButtonStyles}
                    onClick={this.togglePanel}
                    title={isPanelOpen ? "Close panel" : "Open panel"}
                >
                    {isPanelOpen ? "✕" : "Chat"}
                </button>

                {/* Main Content Panel */}
                <div style={mainPanelStyles} className="fremont-page-width">
                    {this.props.children}
                </div>

                {/* Resize Handle - only visible when panel is open */}
                {isPanelOpen && (
                    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                    <div
                        style={resizeHandleStyles}
                        onMouseDown={this.handleMouseDown}
                        title="Drag to resize panels"
                        role="navigation"
                    >
                        <div style={resizeIndicatorStyles}/>
                    </div>
                )}

                {/* Right Panel - only rendered when open */}
                {isPanelOpen && (
                    <div style={rightPanelStyles}>
                        {this.props.rightPanelContent}
                    </div>
                )}
            </div>
        );
    }
}
